import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@smarsh-cyber/app-state';

@Injectable({ providedIn: 'root' })
export class AppMainFacadeService {
  #store = inject(Store<AppState>);
  readonly isError = this.#store.selectSignal(
    (state: AppState) => state.app.isError
  );

  readonly isLoaded = this.#store.select(
    (state: AppState) => state?.app?.isLoaded
  );

  readonly error = this.#store.selectSignal(
    (state: AppState) => state?.app?.error
  );
  readonly user = this.#store.selectSignal((state: AppState) => state.app.user);
}
